// Formik's submitForm() only awaits onSubmit if onSubmit returns the promise.
// Previously this promise was fire-and-forgotten in TaskFormStack, so
// submitForm().then() in TaskCreateBottomSheet fired before createTask had
// resolved — clearing the loading state and resetting the form while the
// request was still in flight, and losing the user's data on failure instead
// of allowing retry (TA-10210 QA fail). The rejection is left unswallowed so
// TaskCreateBottomSheet can tell success from failure.
export const createTaskFormSubmitHandler =
  <TValues>(submit: (values: TValues) => Promise<void>) =>
  (
    values: TValues,
    { setSubmitting }: { setSubmitting: (b: boolean) => void }
  ) =>
    submit(values).finally(() => setSubmitting(false));
